<p>confirmation-dialog works!</p>
